import styled from 'styled-components';

export const HotelAmenitiesWrapOuterDiv = styled.div(
  props => `

  border-top: 1px solid ${props.theme.colors.goBrandBlue.light};
  border-bottom: 1px solid ${props.theme.colors.goBrandBlue.light};
  // padding:${props.theme.spacing.xlarge} 0 ${props.theme.spacing.xlarge} ${props.theme.spacing.small};
  // padding: ${props.theme.spacing.base} 0;
  padding: ${props.theme.spacing.base} 0 ${props.theme.spacing.small} 0;
  min-height: 165px;
`,
);

export const AmenitiesMore = styled.a(
  props => `

  color: ${props.theme.colors.goBrandBlue.base};
  font-size: 12px;
  padding-left:${props.theme.spacing.small};
  padding-right:${props.theme.spacing.base};
  margin-bottom:${props.theme.spacing.large};
`,
);

export const CoupleFriendlyText = styled.p(
  props => `
  display:flex;
  color:${props.theme.colors.goRed.base};
  padding-left:${props.theme.spacing.small};
`,
);

export const HotelDetailsWrapOuterDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;

`,
);

export const AmenityContainer = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 ${props.theme.spacing.base} 0;
`,
);

export const IconContainer = styled.div(
  props => `
  padding: 0 ${props.theme.spacing.base} 0 0;
  display: flex;
  alignItems: center;
`,
);
